
<script>
  try{
    parent.postMessage("surveysubmited", "*");
  }
  catch
  {
    return true;
  }
  </script>

  <script language='javascript' type='text/javascript'>{{ThankYouMessage?.cusotomScript}} </script>
<div class="thankYouMsgWrapper survey-border" [ngClass]="{'full-survey-width' : (surveyWidthType == 3),
              'medium-survey-width' : (surveyWidthType == 2),
              'small-survey-width' : (surveyWidthType == 1),
              'RTLDir' : isRTL}">
              <img src={{thankYouGifURL}}
              style="height:1px;width:1px;border-width:0px;" />
  <div *ngIf="SurveyLogoImageUrl" class="survey-logo thank-you">
    <div
      [ngClass]="SurveyLogoAlign == 1 ? 'align-l' : (SurveyLogoAlign == 2) ? 'align-c': (SurveyLogoAlign == 3) ? 'align-r' : '' ">
      <app-image-control [imageName]="SurveyLogoImageUrl" [imagePath]="undefined" [imageRedirectURL]="undefined">
      </app-image-control>
    </div>
  </div>

  <div class="clsThankYou image-center"
    [innerHTML]="(ThankYouMessage?.ThankyouPage ? ThankYouMessage?.ThankyouPage : '')  | headerFooterHtml"></div>
    <div class="offline-btns-wrapper clearfix1" style="text-align:center;" *ngIf="isOfflineSurvey">
     <div *ngIf="OfflineResponseData.length <= 99" class=" r-record-btn" style="margin:0 auto;" value="Start" (click)="RecordResponse()" >
      <div class="r-plus">+</div>
      Record New Response
    </div>
    <div class="r-upload r-home" style="float: none;display: inline-block;margin-top: 40px;" value="Go Home" (click)="OfflineDashboard()">
      <div class="r-upload-text">Return Home</div>
    </div>
    </div>

  <div *ngIf="ThankYouMessage.isThankYou == '0'" class="ResponseRecorded">
    <span> {{ResponseRecorded}} </span>
  </div>
  <div id='mask' class=''></div>
  <div class="modalWindow" id="viralinvitepop" style="display:none;" runat="server">
    <div [innerHTML]="ThankYouMessage?.viralinvitepop | headerFooterHtml"></div>
  </div>

</div>
<div *ngIf="ThankYouMessage?.ShowBtnContinue" [ngClass]="isMobile ? '' : 'navigation-band' ">
  <div [innerHTML]="ThankYouMessage?.ContinueThankyouMsgInfo | headerFooterHtml"></div>
</div>


<div *ngIf="!isPowredByClient" class="footer-div main-footer-div thank-you-footer">
  <div [innerHTML]="PoweredByText | headerFooterHtml"></div>
</div>
